var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopTalk({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 206.43 238.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M159.21,83.92h-3.8v99.52h19.74v18.48a5.43,5.43,0,0,1-5.43,5.44H130.07v-4.85a6.59,6.59,0,0,0-6.59-6.59H79.1a6.59,6.59,0,0,0-6.59,6.59v18a6.59,6.59,0,0,0,6.59,6.59H196.31V83.92Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M149.72,83.92h-8.2a11.45,11.45,0,0,0-11.45,11.44V172a11.45,11.45,0,0,0,11.45,11.45h8.2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.06,183.45A11.45,11.45,0,0,0,72.51,172V95.36A11.45,11.45,0,0,0,61.06,83.92H53.88v99.53Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.27,9V171a12.49,12.49,0,0,0,12.49,12.49H48.18V83.92H27.43V35.21a5,5,0,0,1,5-5H170.12a5,5,0,0,1,5,5v28.6a6.59,6.59,0,0,0,6.59,6.59h14.57V9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopTalk);
export default __webpack_public_path__ + "static/media/shopTalk.ac7a7f692435411bfca362e809954772.svg";
export { ForwardRef as ReactComponent };